/**
 * Terms and Conditions Page
 * Legal terms of service for HipotecaFácil
 */

import { renderNavbar } from '../components/navbar.js';
import { renderFooter } from '../components/footer.js';

export function renderTerms(container) {
    container.innerHTML = `
    ${renderNavbar()}
    
    <main class="legal-page">
      <div class="container">
        <div class="legal-content animate-fadeIn">
          <h1 class="legal-title">Términos y Condiciones</h1>
          <p class="legal-updated">Última actualización: 9 de enero de 2026</p>
          
          <section class="legal-section">
            <h2>1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar HipotecaFácil ("el Servicio"), aceptas estos Términos y Condiciones 
              en su totalidad. Si no estás de acuerdo con alguna parte de estos términos, no debes 
              utilizar el Servicio.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>2. Descripción del Servicio</h2>
            <p>
              HipotecaFácil es una plataforma educativa e informativa que proporciona:
            </p>
            <ul>
              <li>Guías paso a paso sobre el proceso de obtención de hipotecas en España</li>
              <li>Calculadoras financieras para estimar capacidad de ahorro y gastos</li>
              <li>Información sobre ayudas públicas disponibles por comunidad autónoma</li>
              <li>Herramientas de planificación financiera personal</li>
            </ul>
          </section>
          
          <section class="legal-section">
            <h2>3. Descargo de Responsabilidad</h2>
            <div class="alert alert-warning">
              <i data-feather="alert-triangle"></i>
              <div>
                <strong>Aviso importante:</strong> HipotecaFácil NO constituye asesoramiento financiero, 
                legal, fiscal ni de inversión. La información proporcionada es meramente orientativa 
                y educativa.
              </div>
            </div>
            <p>
              Te recomendamos encarecidamente que consultes con profesionales cualificados 
              (asesores financieros, abogados, gestores) antes de tomar cualquier decisión 
              relacionada con la compra de vivienda o contratación de hipotecas.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>4. Suscripción y Pagos</h2>
            <p><strong>Período de Prueba:</strong></p>
            <ul>
              <li>Ofrecemos 7 días de prueba gratuita al registrarse</li>
              <li>Durante este período, tendrás acceso completo a todas las funcionalidades</li>
              <li>No se realizarán cargos durante el período de prueba</li>
            </ul>
            
            <p><strong>Planes de Suscripción:</strong></p>
            <ul>
              <li><strong>Mensual:</strong> 9,99€/mes</li>
              <li><strong>Anual:</strong> 79,99€/año (equivalente a 2 meses gratis)</li>
            </ul>
            
            <p>
              Los pagos se procesan de forma segura a través de Stripe. Puedes cancelar tu suscripción 
              en cualquier momento desde tu panel de control.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>5. Cuenta de Usuario</h2>
            <p>Al crear una cuenta, te comprometes a:</p>
            <ul>
              <li>Proporcionar información verdadera y actualizada</li>
              <li>Mantener la confidencialidad de tu contraseña</li>
              <li>Notificarnos inmediatamente cualquier uso no autorizado de tu cuenta</li>
              <li>No compartir tu cuenta con terceros</li>
            </ul>
          </section>
          
          <section class="legal-section">
            <h2>6. Propiedad Intelectual</h2>
            <p>
              Todos los contenidos del Servicio (textos, gráficos, logos, iconos, software, etc.) 
              son propiedad de HipotecaFácil o sus licenciantes y están protegidos por las leyes 
              de propiedad intelectual.
            </p>
            <p>
              No está permitida la reproducción, distribución o modificación de los contenidos sin 
              autorización expresa por escrito.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>7. Limitación de Responsabilidad</h2>
            <p>
              En la máxima medida permitida por la ley, HipotecaFácil no será responsable de:
            </p>
            <ul>
              <li>Daños directos o indirectos derivados del uso del Servicio</li>
              <li>Pérdidas financieras resultantes de decisiones basadas en la información proporcionada</li>
              <li>Inexactitudes o errores en los cálculos o información mostrada</li>
              <li>Interrupciones en el servicio o pérdida de datos</li>
            </ul>
          </section>
          
          <section class="legal-section">
            <h2>8. Modificaciones</h2>
            <p>
              Nos reservamos el derecho de modificar estos Términos en cualquier momento. 
              Los cambios entrarán en vigor tras su publicación en esta página. El uso 
              continuado del Servicio tras cualquier modificación constituye la aceptación 
              de los nuevos términos.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>9. Ley Aplicable</h2>
            <p>
              Estos Términos se rigen por la legislación española. Para cualquier controversia, 
              las partes se someten a los Juzgados y Tribunales de Madrid, España.
            </p>
          </section>
          
          <section class="legal-section">
            <h2>10. Contacto</h2>
            <p>
              Para cualquier consulta sobre estos Términos, puedes contactarnos en:
            </p>
            <ul>
              <li>Email: legal@hipotecafacil.es</li>
            </ul>
          </section>
          
          <div class="legal-footer">
            <a href="/" data-link class="btn btn-secondary">
              <i data-feather="arrow-left"></i>
              Volver al inicio
            </a>
          </div>
        </div>
      </div>
    </main>
    
    ${renderFooter()}
  `;
}
